<template>
    <solid-box :title="moduleName">
        <div class="count-list">
            <div class="item -one">
                <div class="item-icon-img all-center">
                    <img src="../../../assets/images/loan_amount.png" alt="" />
                </div>
                <div class="title">累计贷款金额（万元）</div>
                <div class="text">
                    {{ tradeSum.mortgageSummary.amount || 0 }}
                </div>
            </div>
            <div class="item -two">
                <div class="item-icon-img all-center">
                    <img src="../../../assets/images/loan_number.png" alt="" />
                </div>
                <div class="title">累计贷款数量（笔）</div>
                <div class="text">
                    {{ tradeSum.mortgageSummary.number || 0 }}
                </div>
            </div>
        </div>
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'

/**
 * 金融贷款
 */
export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        },
        moduleName: {
            type: String,
            default: ''
        }
    },
    components: {
        SolidBox
    },
    data() {
        return {}
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 450px;
    height: 215px;
    margin: 17px auto 0;
}

.count {
    font-size: 22px;
    line-height: 30px;
    position: absolute;
    bottom: 42px;
    right: 38px;
    color: #fff;

    > .number {
        color: #ffa106;
        font-size: 40px;
        font-weight: bold;
    }
}

.count-list {
    padding: 6px 90px 0;
    display: flex;
    justify-content: space-between;

    > .item {
        text-align: center;
        > .item-icon-img {
            width: 162px;
            height: 150px;
            background-image: linear-gradient(
                90deg,
                rgba(18, 52, 81, 0.8) 4%,
                rgba(18, 52, 81, 0.5) 48%,
                rgba(18, 52, 81, 0.1) 96%
            );
            border-radius: 8px;
            margin: 0 auto;
            img {
                width: 65px;
            }
        }
        > .title {
            line-height: 22px;
            font-size: 16px;
            color: #0bf9d9;
            margin-top: 10px;
        }

        > .text {
            font-size: 40px;
            color: #ffffff;
            margin-top: 4px;
            text-shadow: 0 2px 4px rgba(255, 255, 255, 0.5);
            font-weight: bold;
            line-height: 44px;
        }
    }
}
</style>
